import { OverlayTrigger, Tooltip } from 'react-bootstrap';

//components
import Button from '../../../../components/CustomButton/CustomButton';
import TablePagination from '../../../../components/GenericList/TablePagination';

//utils
import { GROUP_ROLES, countGranted } from './permissionGroupUtils';

const ROLE_FILTERS = [{ value: '', label: 'All' }, ...GROUP_ROLES];

const PermissionGroupList = ({
    t,
    groups,
    selectedId,
    search,
    roleFilter,
    isDirty,
    page,
    pages,
    total,
    onSearchChange,
    onSearchSubmit,
    onRoleFilterChange,
    onPageChange,
    onSelect,
    onCreate,
}) => {
    return (
        <div className="card custom-card perm-group-card">
            <div className="card-header d-flex align-items-center justify-content-between">
                <span className="fw-bold">
                    {t('Permission Groups')}
                    <span className="badge rounded-1 text-primary-color ms-2">{total}</span>
                </span>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tip-new-group">{t('Create a new permission group')}</Tooltip>}>
                    <Button fill sm onClick={onCreate}>
                        <i className="fa fa-plus me-1" aria-hidden="true" />{t('New')}
                    </Button>
                </OverlayTrigger>
            </div>

            <div className="card-body pt-2 pb-0">
                <div className="conversation-search mb-2">
                    <input
                        type="text"
                        className="conversation-search-input"
                        placeholder={t('Search permission group')}
                        value={search}
                        onChange={e => onSearchChange(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter') onSearchSubmit(); }}
                    />
                    <i className="fa fa-search conversation-search-icon" onClick={() => onSearchSubmit()} />
                </div>
                <div className="d-flex mb-2">
                    {ROLE_FILTERS.map((role, index) => (
                        <button
                            key={role.value || 'all'}
                            type="button"
                            className={`tab-btn perm-group-filter-btn${index === 0 ? ' tab-btn-left' : ''}${index === ROLE_FILTERS.length - 1 ? ' tab-btn-right' : ''}${roleFilter === role.value ? ' active' : ''}`}
                            onClick={() => onRoleFilterChange(role.value)}
                        >
                            {t(role.label)}
                        </button>
                    ))}
                </div>
            </div>

            <div className="perm-group-scroll">
                {!groups.length ? (
                    <div className="d-flex flex-column align-items-center justify-content-center text-center px-3 perm-group-empty">
                        <span className="font-size-12 text-dark">
                            {groups.length
                                ? t('No permission group matches your search')
                                : t('No permission group yet. Create one to apply the same permissions to many employees at once.')}
                        </span>
                    </div>
                ) : (
                    <div>
                        {groups.map(group => {
                            const isActive = group.id === selectedId;
                            const memberCount = (group.members || []).length;
                            const customised = (group.members || []).filter(m => m.is_customised).length;
                            return (
                                <button
                                    key={group.id}
                                    type="button"
                                    className={`perm-group-item${isActive ? ' active' : ''}`}
                                    onClick={() => onSelect(group.id)}
                                >
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <span className="fw-bold font-size-12 text-truncate text-dark">{group.name}</span>
                                        <span className={`perm-group-role${group.user_type === 'pm' ? '' : ' perm-group-role-member'}`}>
                                            {t(group.user_type === 'pm' ? 'PM' : 'Member')}
                                        </span>
                                    </div>
                                    {group.description ? (
                                        <div className="font-size-10 text-dark text-truncate mt-1">{group.description}</div>
                                    ) : null}
                                    <div className="d-flex align-items-center flex-wrap gap-3 mt-1 font-size-10 text-dark">
                                        <span>{memberCount} {t('employees')}</span>
                                        <span>{countGranted(group.permissions)} {t('granted')}</span>
                                        {customised ? (
                                            <span className="text-dark">{customised} {t('customised')}</span>
                                        ) : null}
                                    </div>
                                    {isActive && isDirty ? (
                                        <div className="font-size-10 fw-bold text-danger mt-1">
                                            {t('Unsaved changes')}
                                        </div>
                                    ) : null}
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>

            {pages > 1 ? (
                <div className="card-footer bg-white py-2">
                    <TablePagination
                        // the component keeps its own active page, so remount it when
                        // a filter change resets us to page one
                        key={`${roleFilter}|${search.trim()}`}
                        pages={pages}
                        page={page - 1}
                        handlePagination={onPageChange}
                        requestData={() => { }}
                        filters={{}}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default PermissionGroupList;
